import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../Shared/Button';
import { FlexWrapper } from '../Shared/FlexWrapper';
import { ErrorLayout } from './Layouts';

export const errorDescriptions = {
    unauthorized: 'You are not authorized to access this site.',
    access_denied: 'Access has been denied to this site.',
    too_many_attempts: 'The account is blocked due to too many attempts to sign in',
};

interface Properties {
    children: React.ReactNode;
}

export const AuthenticationErrorsWrapper: React.FC<Properties> = ({ children }): React.ReactElement => {
    const { search } = useLocation();

    const queryParams = new URLSearchParams(search);

    const [showErrors, setShowErrors] = React.useState<boolean>(false);

    React.useEffect(() => {
        window.history.replaceState(null, '', '/');
    }, []);

    const getErrorMessage = (error: string | null) => {
        if (error == null) return 'error parameter not provided';

        return errorDescriptions[error] || 'Error Message Not Found';
    };

    const isErrorExpiredOrUsedInvitation = (): boolean => {
        if(queryParams.get('error_description') === 'invitation not found or already used') {
            return true;
        }
        return false;
    };

    return (
        <>
            {queryParams.has('error') ? (
                <ErrorLayout>
                    <FlexWrapper align="center" justify="center" column fullWidth style={{ margin: '0 0 1rem' }}>
                        <h1>{getErrorMessage(queryParams.get('error'))}</h1>
                        <p style={{ margin: '0 0 1rem', maxWidth: '30rem' }}>
                            If you have questions about this error, please contact support for more information.
                        </p>
                        <p style={{ margin: '0 0 1rem', maxWidth: '30rem' }}>
                            Customer support may ask for you to provide the following details.
                        </p>
                        <Button
                            withMarginBottom
                            callback={() => setShowErrors(!showErrors)}
                            text={`${showErrors ? 'Hide' : 'Show'} Error Details`}
                        />
                        <p>{showErrors && queryParams.get('error_description')}</p>

                        {isErrorExpiredOrUsedInvitation() && (
                            <a href="/">
                                This link is no longer valid. If you've already created an account, click here to log in.
                            </a>
                        )}
                    </FlexWrapper>
                </ErrorLayout>
            ) : (
                children
            )}
        </>
    );
};
